import { defineMessages } from "react-intl";

const PREFIX = "Navigation.HeaderNavigation";
export default defineMessages({
  home: {
    id: `${PREFIX}.home`,
    defaultMessage: "Home",
  },
  help: {
    id: `${PREFIX}.help`,
    defaultMessage: "Help",
  },
  subscriptions: {
    id: `${PREFIX}.subscriptions`,
    defaultMessage: "Subscriptions",
  },
  favourites: {
    id: `${PREFIX}.favourites`,
    defaultMessage: "Favourites",
  },
});
